import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Button,
  TextField,
  IconButton,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Grid,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Card,
  CardContent,
  Menu,
  MenuItem,
  Modal,
  Select,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Checkbox,
  FormHelperText,
  TablePagination,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import { Notifications } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import AppHeaderBar from "../../components/AppBar/appBar";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Delete, UploadFile } from "@mui/icons-material";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";
import {
  validateName,
  validateShopName,
  validateEmail,
  validatePhoneNumber,
  validateDropdown,
  validateDropdownForArray,
  validateDOB,
  validateAadhar,
  validatePAN,
  validateGST,
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../utils/textFieldValidations";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
  convertDateToDateMonthYear,
  convertDateFormat,
} from "../../utils/DateFormats";

const VendorManagement = ({ onBackScreenName }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null); // Reference to the Marker
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const imageInputRef = useRef(null);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [selectedStoreImageFile, setSelectedStoreImageFile] = useState(null);
  const [page, setPage] = useState(0);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [endTime, setEndTime] = useState("");
  const [dob, setDob] = useState(new Date());
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [profileImage, setProfileImage] = useState(null);
  const [data, setData] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [errors, setErrors] = useState({});
  const [natureData, setNatureData] = useState([]);
  const [moduleStatusData, setModuleStatusData] = useState({});
  const [categoryData, setCategoryData] = useState({});
  const [listingCategoryData, setListingCategoryData] = useState({});
  const [locationSearch, setLocationSearch] = useState("");
  const [id, setId] = useState(4); //For Vendor Mangement id is 4
  const [vendorTypeTab, setVendorTypeTab] = useState("regular");
  const statusURL = BASE_URL_TEST + urls("getStatusById", id);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const [vendorData, setVendorData] = useState({
    name: "",
    shopName: "",
    location: "",
    email: "",
    phoneNumber: "",
    businessNature: "",
    status: "",
    category: "" || [],
    profilePhoto: "",
    storeImage: "",
    openingTime: "",
    eveningTime: "",
    dob: "",
    aadhar: "",
    pan: "",
    gst: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    searchlocation: "",
    latitude: "",
    longitude: "",
    password: "",
    id: "",
    productType: "",
    listingCategory: "" || [],
  });
  const [vendorviewData, setVendorviewData] = useState({
    vendorId: "",
    shopName: "",
    ownerName: "",
    phoneNumber: "",
    location: "",
    status: "",
    email: "",
    address: "",
  });

  const loginToken = useSelector((state) => state?.user?.logintoken);
  const userDetails = useSelector(
    (state) => (state?.user || {}).userdetails || {},
  );
  const vendorId = userDetails?.vendor_id ?? userDetails?.id;
  const libraries = ["places"];
  console.log("userDetails", userDetails);
  const [loading, setLoading] = useState(false);
  const sampleData = [
    { name: "John Doe", age: 30, email: "john@example.com" },
    { name: "Jane Smith", age: 25, email: "jane@example.com" },
    { name: "Bob Johnson", age: 35, email: "bob@example.com" },
  ];
  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8", // Your API key here
      libraries,
    });

    return { isLoaded, loadError };
  };
  const { isLoaded, loadError } = useGoogleMaps();
  //get All vendors data
  useEffect(() => {
    fetchData();
    fetchBusinessNatureData();
    fetchStatus();

    if (vendorId) {
      fetchDashboardCounts();
      //console.log("vendoris",vendorId)
    }
  }, [vendorId]);
  useEffect(() => {
    if (vendorData?.productType === "regular") {
      fetchCategory(); // regular categories
    } else if (vendorData?.productType === "listing") {
      fetchListingCategory(); // listing categories
    }
  }, [vendorData?.productType]);

  //get All vendors data
  const {
    data: vendorsData,
    isLoading: isVendorsLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllVendors"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  //get Business Nature data
  const {
    data: businessNatureData,
    isLoading: isbusinessNatureLoading,
    error: businessNatureError,
    fetchData: fetchBusinessNatureData,
  } = useFetch(BASE_URL_TEST + urls("getAllBNature"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  //get status data
  const {
    data: allStatusData,
    isLoading: isStatusLoading,
    error: statusError,
    fetchData: fetchStatus,
  } = useFetch(statusURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  //get All categories data
  const {
    data: allCategoryData,
    isLoading: isCategoryLoading,
    error: categoryError,
    fetchData: fetchCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  //get All Listing categories data
  const {
    data: allListingCategoryData,
    isLoading: isListingCategoryLoading,
    error: listingCategoryError,
    fetchData: fetchListingCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createVendorsData,
    isLoading: createVendorsLoading,
    error: createVendorsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVendor"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateVendorsData,
    isLoading: updateVendorsLoading,
    error: updateVendorsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteVendorsData,
    isLoading: deleteVendorsLoading,
    error: deleteVendorsError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const [viewVendorId, setViewVendorId] = useState(null);
  const paymentRequestsUrl = viewVendorId
    ? `${BASE_URL_TEST}${urls("getVendorPaymentRequests")}?vendor_id=${viewVendorId}&status=completed`
    : null;

  const {
    data: paymentRequestsData,
    isLoading: paymentRequestsLoading,
    error: paymentRequestsError,
    fetchData: fetchPaymentRequests,
  } = useFetch(paymentRequestsUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Add this useEffect - triggers fetch when viewVendorId changes
  useEffect(() => {
    if (viewVendorId) {
      fetchPaymentRequests();
    }
  }, [viewVendorId]);
  const bankDetails =
    paymentRequestsData?.data?.[0]?.vendorDetails?.bankDetails || [];
  useEffect(() => {
    if (error) {
    } else if (vendorsData && vendorsData["status"] === true) {
      setData(vendorsData["data"]);
    }
  }, [vendorsData, error]);

  //business nature useEffect

  useEffect(() => {
    if (businessNatureError) {
    } else if (businessNatureData && businessNatureData["status"] === true) {
      setNatureData(businessNatureData["data"]);
    }
  }, [businessNatureData, businessNatureError]);

  //getstatus useEffect
  useEffect(() => {
    if (statusError) {
    } else if (allStatusData && allStatusData["status"] === true) {
      setModuleStatusData(allStatusData["data"]);
    }
  }, [allStatusData, statusError]);

  //get All categories useEffect
  useEffect(() => {
    if (categoryError) {
    } else if (allCategoryData && allCategoryData["status"] === true) {
      const filteredCategories = allCategoryData["data"].filter(
        (item) => item.status === 1,
      );

      setCategoryData(filteredCategories);
    }
  }, [allCategoryData, categoryError]);

  //get All Listing categories useEffect
  useEffect(() => {
    if (listingCategoryError) {
    } else if (
      allListingCategoryData &&
      allListingCategoryData["status"] === true
    ) {
      const filteredListingCategories = allListingCategoryData["data"].filter(
        (item) => item.status === 1,
      );

      setListingCategoryData(filteredListingCategories);
    }
  }, [allListingCategoryData, listingCategoryError]);

  //Create Vendor
  useEffect(() => {
    if (createVendorsError) {
    } else if (createVendorsData && createVendorsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createVendorsData["message"],
        status: createVendorsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createVendorsData && createVendorsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createVendorsData["message"],
        status: createVendorsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createVendorsData, createVendorsError]);

  //Update Vendor
  useEffect(() => {
    if (updateVendorsError) {
    } else if (updateVendorsData && updateVendorsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateVendorsData && updateVendorsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateVendorsData, updateVendorsError]);

  const {
    data: deliveredOrdersData,
    isLoading: deliveredOrdersLoading,
    error: deliveredOrdersError,
    fetchData: fetchDeliveredOrders,
  } = useFetch(BASE_URL_TEST + urls("getMyOrders"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const totalOrders = deliveredOrdersData?.data?.total_orders || 0;

  const totalReceivedAmount = deliveredOrdersData?.data?.total_amount || 0;
  //Delete Vendor
  useEffect(() => {
    if (deleteVendorsError) {
    } else if (deleteVendorsData && deleteVendorsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteVendorsData["message"],
        status: deleteVendorsData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteVendorsData && deleteVendorsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteVendorsData["message"],
        status: deleteVendorsData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteVendorsData, deleteVendorsError]);

  const dashboardCountsUrl = vendorId
    ? BASE_URL_TEST + urls("getdashBoardCounts", vendorId)
    : null;

  const {
    data: dashboardResponse,
    isLoading: isDashboardLoading,
    dashboardError,
    fetchData: fetchDashboardCounts,
  } = useFetch(dashboardCountsUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const dashboardData = dashboardResponse?.data;
  console.log("dashboardData", dashboardData);
  const cards = [
    {
      title: "Products left in inventory",
      value: dashboardData?.product_left_inventory || "0",
      image: "/totalProducts.svg",
    },
    {
      title: "Today Total Order Count",
      value: dashboardData?.today_total_orders?.toString() || "0",
      image: "/orders.svg",
    },
    {
      title: "Cancelled Orders",
      value: dashboardData?.cancelled_orders?.toString() || "0",
      image: "/orders.svg",
    },
    {
      title: "Total Order Values",
      value: dashboardData?.total_order_sales
        ? `₹${parseFloat(dashboardData.total_order_sales).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        : "₹0.00",
      image: "/Flag.svg",
    },
    {
      title: "New Orders",
      value: dashboardData?.new_orders?.toString() || "0",
      image: "/topProducts.svg",
    },
  ];

  const initializeVendors = () => {
    setVendorData({
      name: "",
      shopName: "",
      location: "",
      email: "",
      phoneNumber: "",
      businessNature: "",
      status: "",
      category: "",
      profilePhoto: "",
      storeImage: "",
      openingTime: "",
      eveningTime: "",
      dob: "",
      aadhar: "",
      pan: "",
      gst: "",
      country: "",
      state: "",
      city: "",
      street: "",
      landmark: "",
      pincode: "",
      searchlocation: "",
      latitude: vendorData?.latitude,
      longitude: vendorData?.longitude,
      password: "",
      productType: "",
      listingCategory: "",
    });
  };

  const clearErrors = () => {
    setErrors({});
  };

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  useEffect(() => {
    setPage(0);
  }, [search, vendorTypeTab]);

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.id - a.id)
          .filter(
            (item) =>
              (item.id &&
                item.id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.vendor_id &&
                item.vendor_id.toLowerCase().includes(search.toLowerCase())) ||
              (item.name &&
                item.name.toLowerCase().includes(search.toLowerCase())) ||
              (item.shop_name &&
                item.shop_name.toLowerCase().includes(search.toLowerCase())) ||
              (item.location &&
                item.location.toLowerCase().includes(search.toLowerCase())) ||
              (item.email &&
                item.email.toLowerCase().includes(search.toLowerCase())) ||
              (item.phone_number &&
                item.phone_number.toString().includes(search.toLowerCase())) ||
              (item.status &&
                item.status.toLowerCase().includes(search.toLowerCase())),
          )
      : data;

  const filteredDataByType = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return [];

    return filteredData.filter(
      (vendor) => vendor.reg_list_type === vendorTypeTab,
    );
  }, [filteredData, vendorTypeTab]);

  useEffect(() => {
    if (!search) return;
    if (!filteredData || filteredData.length === 0) return;

    const hasRegularMatches = filteredData.some(
      (v) => v.reg_list_type === "regular",
    );
    const hasListingMatches = filteredData.some(
      (v) => v.reg_list_type === "listing",
    );

    if (
      vendorTypeTab === "regular" &&
      !hasRegularMatches &&
      hasListingMatches
    ) {
      setVendorTypeTab("listing");
    } else if (
      vendorTypeTab === "listing" &&
      !hasListingMatches &&
      hasRegularMatches
    ) {
      setVendorTypeTab("regular");
    }
  }, [search, filteredData]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const TabPanel = ({ children, value, index }) => {
    return (
      <div hidden={value !== index}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  };

  const handleAdd = () => {
    setEditMode(false);
    initializeVendors();
    clearErrors();
    setOpen(true);
  };

  const handleEdit = async (vendor) => {
    setEditMode(true);
    setOpen(true);
    let categoryNames = "";
    let categoryIds = [];
    let listingCategoryNames = "";
    let listingcategoryIds = [];
    if (vendor.categories) {
      categoryNames = vendor.categories
        .map((category) => category.name)
        .join(", ");
      categoryIds = vendor.categories.map((category) => category.category_id);
    }

    if (vendor.listCategories) {
      listingCategoryNames = vendor.listCategories
        .map((listingcategory) => listingcategory.name)
        .join(", ");
      listingcategoryIds = vendor.listCategories.map(
        (listingcategory) => listingcategory.category_id,
      );
    }

    setVendorData({
      ...vendorData,
      name: vendor["name"],
      shopName: vendor["shop_name"],
      location: vendor["location"],
      email: vendor["email"],
      phoneNumber: vendor["phone_number"],
      businessNature: vendor["business_id"],
      status: vendor["status"],
      category: categoryIds,
      listingCategory: listingcategoryIds,
      profilePhoto: vendor["profile"],
      storeImage: vendor["store_image"],
      openingTime: vendor["open_time"],
      eveningTime: vendor["close_time"],
      // dob: vendor["dob"]
      //   ? convertYearMonthDateToMonthDateYear(vendor["dob"])
      //   : null,
      dob: vendor["dob"] ? convertDateFormat(vendor["dob"]) : null,
      aadhar: vendor["aadhar"],
      pan: vendor["pancard"],
      gst: vendor["gstn_no"],
      country: vendor["country"],
      state: vendor["state"],
      city: vendor["city"],
      street: vendor["street"],
      landmark: vendor["landmark"],
      pincode: vendor["pincode"],
      latitude: vendor["latitude"],
      longitude: vendor["longitude"],
      id: vendor["id"],
      productType: vendor["reg_list_type"],
    });
    if (vendor.latitude && vendor.longitude) {
      const latitude = parseFloat(vendor.latitude);
      const longitude = parseFloat(vendor.longitude);
      try {
        const reverseGeocodeResponse = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${vendor.latitude},${vendor.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
        );
        const reverseGeocodeData = await reverseGeocodeResponse.json();

        if (
          reverseGeocodeData.results &&
          reverseGeocodeData.results.length > 0
        ) {
          const address = reverseGeocodeData.results[0].formatted_address;

          // Update vendor data with the formatted address (location)
          setVendorData((prevData) => ({
            ...prevData,
            searchlocation: address,
          }));
        }
        setTimeout(() => {
          if (mapRef.current) {
            const map = mapRef.current;
            const center = { lat: latitude, lng: longitude };
            map.panTo(center);
            map.setZoom(15);
          }

          if (markerRef.current) {
            markerRef.current.setPosition({ lat: latitude, lng: longitude });
          }
        }, 100);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
    setAnchorEl(null);
  };

  const handleDelete = (vendorId) => {
    const deleteUrl = urls("deleteVendor", vendorId);
    fetchDeleteData(deleteUrl);
  };

  const handleSubmit = () => {
    let validationErrors = {};
    if (!validateName(vendorData.name)) {
      validationErrors.name =
        "Name is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateShopName(vendorData.shopName)) {
      validationErrors.shopName =
        "Shop Name is required and can contain letters, numbers, spaces, hyphens, and apostrophes.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCity(vendorData.location)) {
      validationErrors.location =
        "Location is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateEmail(vendorData.email)) {
      validationErrors.email = "Please enter a valid email address.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePhoneNumber(vendorData.phoneNumber)) {
      validationErrors.phoneNumber = "Please enter a 10 digit phone number.";
      setErrors(validationErrors);
      return;
    }
    if (!vendorData.productType) {
      validationErrors.productType = "Please select product type.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDropdownForArray(vendorData.businessNature)) {
      validationErrors.businessNatureDropdown =
        "Please select business nature.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDropdownForArray(vendorData.status)) {
      validationErrors.statusDropdown = "Please select status.";
      setErrors(validationErrors);
      return;
    }

    if (vendorData?.productType === "regular") {
      if (!validateDropdownForArray(vendorData.category)) {
        validationErrors.categoryDropdown = "Please select category.";
        setErrors(validationErrors);
        return;
      }
    } else if (vendorData?.productType === "listing") {
      if (!validateDropdownForArray(vendorData.listingCategory)) {
        validationErrors.listingCategoryDropdown =
          "Please select Listing Category.";
        setErrors(validationErrors);
        return;
      }
    }

    // if (!vendorData.profilePhoto) {
    //   validationErrors.profileError = "Store Image is required.";
    //   setErrors(validationErrors);
    //   return;
    // }

    // if (!vendorData.storeImage) {
    //   validationErrors.storeImageError =
    //     "Store image(Banner/Flexi) is required.";
    //   setErrors(validationErrors);
    //   return;
    // }
    if (!vendorData.profilePhoto) {
      validationErrors.profilePhoto =
        "Store Image is required. Please upload an image (300x300, Max 40KB).";
      setErrors(validationErrors);
      return false;
    }

    if (!vendorData.storeImage) {
      validationErrors.storeImage =
        "Store Banner is required. Please upload an image (1250x400, Max 60KB).";
      setErrors(validationErrors);
      return false;
    }

    if (!validateDropdownForArray(vendorData.openingTime)) {
      validationErrors.openingTimeDropdown = "Please select opening time.";
      setErrors(validationErrors);
      return;
    }
    if (!validateDropdownForArray(vendorData.eveningTime)) {
      validationErrors.eveningTimeDropDown = "Please select evening time.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDOB(vendorData.dob)) {
      validationErrors.dob = "Date of birth is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateAadhar(vendorData.aadhar)) {
      validationErrors.aadhar = "Aadhar number must be a 12-digit number.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePAN(vendorData.pan)) {
      validationErrors.pan = "Please enter a valid PAN number.";
      setErrors(validationErrors);
      return;
    }

    if (vendorData.productType === "regular" && !validateGST(vendorData.gst)) {
      validationErrors.gst = "Please enter a valid GST number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCountry(vendorData.country)) {
      validationErrors.country =
        "Country is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateState(vendorData.state)) {
      validationErrors.state =
        "State is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateStreet(vendorData.street)) {
      validationErrors.street =
        "Street Address is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes..";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(vendorData.landmark)) {
      // validationErrors.landmark =
      //   "Landmark is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes.";
      validationErrors.landmark = "Landmark is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePincode(vendorData.pincode)) {
      validationErrors.pincode = "Pincode should be a 6-digit number.";
      setErrors(validationErrors);
      return;
    }
    if (!validateLandmark(vendorData.searchlocation)) {
      validationErrors.searchlocation = "Location is required.";
      setErrors(validationErrors);
      return;
    }

    clearErrors();

    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    let aadharPrefix = vendorData.aadhar.slice(0, 2);
    const covertDate = vendorData.dob ? convertDate(vendorData.dob) : null;
    let dobMonth = covertDate.split("-")[1];
    let dobMonthAbbr = months[parseInt(dobMonth, 10) - 1];

    let dobMonthWithAt = `${dobMonthAbbr}@`;
    let dobYear = covertDate.split("-")[0];
    let dobYearLastTwo = dobYear.slice(2);
    let password = `${aadharPrefix}${dobMonthWithAt}${dobYearLastTwo}`;
    console.log("password", password);
    setVendorData({ ...vendorData, password: password });
    const formdata = new FormData();
    formdata.append("name", vendorData["name"]);
    formdata.append("shop_name", vendorData["shopName"]);
    formdata.append("location", vendorData["location"]);
    formdata.append("email", vendorData["email"]);
    formdata.append("phone_number", vendorData["phoneNumber"]);
    formdata.append("business_id", vendorData["businessNature"]);
    formdata.append("status", vendorData["status"]);
    if (vendorData?.productType === "regular") {
      formdata.append("category_id", vendorData["category"]);
    }
    if (vendorData?.productType === "listing") {
      //formdata.append("listing_ids", vendorData["listingCategory"]);
      formdata.append("category_id", vendorData["listingCategory"]);
    }
    formdata.append(
      "profile",
      selectedProfileFile ? selectedProfileFile : vendorData["profile"],
    );
    formdata.append(
      "store_image",
      selectedStoreImageFile
        ? selectedStoreImageFile
        : vendorData["storeImage"],
    );
    formdata.append("open_time", vendorData["openingTime"]);
    formdata.append("close_time", vendorData["eveningTime"]);
    formdata.append(
      "dob",
      vendorData.dob ? convertDateToDateMonthYear(vendorData.dob) : null,
    );
    formdata.append("aadhar", vendorData["aadhar"]);
    formdata.append("pancard", vendorData["pan"]);
    formdata.append("gstn_no", vendorData["gst"]);
    formdata.append("country", vendorData["country"]);
    formdata.append("state", vendorData["state"]);
    formdata.append("city", vendorData["location"]);
    formdata.append("street", vendorData["street"]);
    formdata.append("landmark", vendorData["landmark"]);
    formdata.append("pincode", vendorData["pincode"]);
    formdata.append("latitude", vendorData["latitude"]);
    formdata.append("longitude", vendorData["longitude"]);
    formdata.append("password", password);

    if (vendorData.productType === "regular") {
      formdata.append("reg_list_type", "regular");
    } else if (vendorData.productType === "listing") {
      formdata.append("reg_list_type", "listing");
    }
    if (isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
        console.log("Form Data Contentsupdate:", `${key}: ${value}`);
      }
      const updateUrl = urls("updateVendor", vendorData["id"]);
      fetchUpdateData(updateUrl, formdata);
    } else if (!isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      fetchCreateData(formdata);
    }
  };

  const handleMenuOpen = (event, vendorId) => {
    setAnchorEl(event.currentTarget);
    setSelectedVendorId(vendorId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  //For View the Vendor data
  const handleView = (event, vendor) => {
    console.log("yamunaavendor", vendor);
    setSelectedVendorId(vendor.id);
    setOpenViewModal(true);
    setViewVendorId(vendor.id);
    setVendorviewData({
      ...vendorviewData,
      vendorId: vendor["id"],
      shopName: vendor["shop_name"],
      ownerName: vendor["name"],
      phoneNumber: vendor["phone_number"],
      location: vendor["location"],
      status: vendor["status"],
      email: vendor["email"],
      address: vendor["city"],
    });

    fetchDeliveredOrders({
      vendor_id: vendor.vendor_id,
      order_status: "DELIVERED",
    });
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
    setViewVendorId(null);
  };

  const StyledPaper = styled(Paper)({
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
  });

  const validateImageFile = (
    file,
    maxSizeKB,
    requiredWidth,
    requiredHeight,
  ) => {
    return new Promise((resolve, reject) => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > maxSizeKB) {
        reject(
          `File size should be less than ${maxSizeKB}KB. Current size: ${Math.round(
            fileSizeKB,
          )}KB`,
        );
        return;
      }

      if (!file.type.match(/image\/(jpeg|jpg|png)/)) {
        reject("Only JPEG and PNG images are allowed");
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        if (img.width !== requiredWidth || img.height !== requiredHeight) {
          reject(
            `Image dimensions should be ${requiredWidth}x${requiredHeight}. Current: ${img.width}x${img.height}`,
          );
        } else {
          resolve(true);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject("Error loading image");
      };

      img.src = objectUrl;
    });
  };

  const handleProfileImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        await validateImageFile(file, 40, 300, 300);
        setVendorData((prevData) => ({
          ...prevData,
          profilePhoto: URL.createObjectURL(file),
        }));
        setSelectedProfileFile(file);
        if (errors.profilePhoto) {
          setErrors((prev) => ({ ...prev, profilePhoto: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, profilePhoto: error }));
        e.target.value = null;
      }
    }
  };

  const handleStoreImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        await validateImageFile(file, 60, 1250, 400);
        setVendorData((prevData) => ({
          ...prevData,
          storeImage: URL.createObjectURL(file),
        }));

        setSelectedStoreImageFile(file);
        if (errors.storeImage) {
          setErrors((prev) => ({ ...prev, storeImage: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, storeImage: error }));
        e.target.value = null;
      }
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const ImageItem = ({ name, error, onRemove }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1,
        border: "1px solid #ddd",
        borderRadius: "4px",
      }}
    >
      <img
        src={name}
        alt="Product thumbnail"
        style={{
          width: "50px",
          height: "50px",
          marginRight: "8px",
          objectFit: "cover",
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {name}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={100}
          sx={{
            height: "6px",
            borderRadius: "2px",
            mt: 1,
            backgroundColor: "inherit",
            "& .MuiLinearProgress-bar": {
              backgroundColor: error ? "red" : "green",
            },
          }}
        />
      </Box>
      <IconButton onClick={onRemove} sx={{ ml: 1 }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
  //commented on 11-02-2025 related to map update
  // useEffect(() => {
  //   console.log("Vendor Data Latitude:", vendorData.latitude);
  //   console.log("Vendor Data Longitude:", vendorData.longitude);
  //   if (vendorData.latitude && vendorData.longitude) {
  //     if (mapRef.current) {
  //       mapRef.current.setCenter({
  //         lat: vendorData.latitude,
  //         lng: vendorData.longitude,
  //       });
  //       mapRef.current.setZoom(15);
  //     }

  //     if (markerRef.current) {
  //       markerRef.current.setPosition({
  //         lat: vendorData.latitude,
  //         lng: vendorData.longitude,
  //       });
  //     }
  //   } else {
  //     // If vendorData doesn't have latitude and longitude, fetch current geolocation
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           const { latitude, longitude } = position.coords;

  //           // Update vendorData with geolocation coordinates
  //           setVendorData((prevData) => ({
  //             ...prevData,
  //             latitude,
  //             longitude,
  //           }));

  //           // Update map and marker with geolocation coordinates
  //           if (mapRef.current) {
  //             mapRef.current.setCenter({
  //               lat: latitude,
  //               lng: longitude,
  //             });
  //             mapRef.current.setZoom(15);
  //           }

  //           if (markerRef.current) {
  //             markerRef.current.setPosition({
  //               lat: latitude,
  //               lng: longitude,
  //             });
  //           }
  //         },
  //         (error) => {
  //           console.error("Geolocation Error:", error);
  //         }
  //       );
  //     } else {
  //       console.log("Geolocation is not supported by this browser.");
  //     }
  //   }
  // }, [vendorData.latitude, vendorData.longitude]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setVendorData((vendorData) => ({
          ...vendorData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);

  // Function to handle location search using Google Maps Geocoding API
  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;
    setVendorData({
      ...vendorData,
      searchlocation: searchValue,
    });

    const query = `${vendorData["country"]}, ${vendorData["state"]}, ${searchValue}`;
    console.log("query", query);

    //if (searchValue) {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          query,
        )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
      );

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        const newLocation = data.results[0].formatted_address;

        // Update vendorData with latitude, longitude, and location
        setVendorData((prevData) => ({
          ...prevData,
          latitude: lat,
          longitude: lng,
        }));

        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(15);
        }
        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      } else {
        console.log("No results found.");
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
    //}
  };

  //close button
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();

    if (createVendorsData && createVendorsData["status"] === true) {
      initializeVendors();
      setVendorData({
        latitude: "",
        longitude: "",
      });
      setOpen(false);
    }
    if (isEditMode) {
      if (updateVendorsData && updateVendorsData["status"] === true) {
        initializeVendors();
        setVendorData({
          latitude: "",
          longitude: "",
        });
        setOpen(false);
      }
    }

    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };

  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const handleDownloadExcel = async () => {
    try {
      setLoading(true);

      const XLSX = await import("xlsx");

      // Map actual vendor data to readable columns
      const exportData = filteredDataByType.map((vendor) => ({
        "Vendor ID": vendor.vendor_id || "",
        Name: vendor.name || "",
        "Shop Name": vendor.shop_name || "",
        Location: vendor.location || "",
        Email: vendor.email || "",
        "Phone Number": vendor.phone_number || "",
        Status: vendor.status || "",
        "Business Nature": vendor.business_nature || "",
        "Opening Time": vendor.open_time || "",
        "Closing Time": vendor.close_time || "",
        Country: vendor.country || "",
        State: vendor.state || "",
        City: vendor.city || "",
        Street: vendor.street || "",
        Landmark: vendor.landmark || "",
        Pincode: vendor.pincode || "",
        Latitude: vendor.latitude || "",
        Longitude: vendor.longitude || "",
        Type: vendor.reg_list_type || "",
      }));

      if (exportData.length === 0) {
        alert("No data available to export.");
        setLoading(false);
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Auto column widths
      const colWidths = Object.keys(exportData[0]).map((key) => ({
        wch: Math.max(
          key.length,
          ...exportData.map((row) => String(row[key] || "").length),
        ),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        vendorTypeTab === "regular" ? "Regular Vendors" : "Listing Vendors",
      );

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${vendorTypeTab === "regular" ? "Regular" : "Listing"}_Vendors_${new Date().toLocaleDateString()}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      {/* {loading ? <Typography>'Downloading...</Typography> : 'Download Excel'} */}
      <AppHeaderBar
        title={" Vendor Management"}
        onBackScreenName={handleScreeName}
      />

      <Box sx={{ p: 3, backgroundColor: "#F9FAFC" }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginBottom: "30px" }}
        >
          <Grid item>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearch}
            />
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadExcel}
            >
              {loading ? "Downloading" : "Download Excel"}
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              style={{ marginLeft: "10px" }}
              onClick={handleAdd}
            >
              Add Vendor
            </Button>
          </Grid>
        </Grid>
        {/* Tabs for Regular and Listing Vendors */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={vendorTypeTab}
            onChange={(e, newValue) => setVendorTypeTab(newValue)}
            aria-label="vendor type tabs"
          >
            <Tab label="Regular Vendors" value="regular" />
            <Tab label="Listing Vendors" value="listing" />
          </Tabs>
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
              <TableRow>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  VendorID
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Shop Name
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Location
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Actions
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDataByType.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography>No records found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredDataByType
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((vendor) => {
                    return (
                      <TableRow key={vendor.id}>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {vendor.vendor_id}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {vendor.name}
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {vendor.shop_name}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {vendor.location}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {vendor.email}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {vendor.phone_number}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            color:
                              vendor.status === "Pending"
                                ? "orange"
                                : vendor.status === "Confirmed"
                                  ? "green"
                                  : vendor.status === "Cancel"
                                    ? "red"
                                    : vendor.status === "Inprogress"
                                      ? "blue"
                                      : "black",
                            fontWeight: "bold",
                          }}
                        >
                          {vendor.status}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            onClick={(e) => handleMenuOpen(e, vendor.id)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={
                              Boolean(anchorEl) &&
                              selectedVendorId === vendor.id
                            }
                            onClose={handleMenuClose}
                          >
                            <MenuItem onClick={() => handleEdit(vendor)}>
                              <EditIcon /> Edit
                            </MenuItem>
                            {/* <MenuItem onClick={() => handleDelete(vendor.id)}>
                              <DeleteIcon /> Delete
                            </MenuItem> */}
                          </Menu>
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={(e) => handleView(e, vendor)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 150]}
          component="div"
          count={data && data.length ? data.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
        <Dialog
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
        >
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal for Add/Edit */}
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll",
              borderRadius: 2,
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
                {vendorData?.id ? "Edit Vendor" : "Add Vendor"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                value={vendorData?.name || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, name: e.target.value })
                }
                error={!!errors.name}
                helperText={
                  errors.name && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.name}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Shop Name"
                type="text"
                fullWidth
                value={vendorData?.shopName || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, shopName: e.target.value })
                }
                error={!!errors.shopName}
                helperText={
                  errors.shopName && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.shopName}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Location"
                type="text"
                fullWidth
                value={vendorData?.location || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, location: e.target.value })
                }
                error={!!errors.location}
                helperText={
                  errors.location && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.location}
                    </Typography>
                  )
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                margin="dense"
                label="Email"
                type="email"
                fullWidth
                value={vendorData?.email || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, email: e.target.value })
                }
                error={!!errors.email}
                helperText={
                  errors.email && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.email}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Phone"
                type="tel"
                fullWidth
                value={vendorData?.phoneNumber || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, phoneNumber: e.target.value })
                }
                error={!!errors.phoneNumber}
                helperText={
                  errors.phoneNumber && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.phoneNumber}
                    </Typography>
                  )
                }
              />
            </Box>

            <FormControl component="fieldset" sx={{ marginTop: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Product Type
              </Typography>
              <RadioGroup
                row
                name="productType"
                value={vendorData?.productType || ""}
                onChange={(e) =>
                  !isEditMode &&
                  setVendorData({ ...vendorData, productType: e.target.value })
                }
              >
                <FormControlLabel
                  value="regular"
                  control={<Radio />}
                  label="Sthanick Stores"
                  disabled={isEditMode}
                />
                <FormControlLabel
                  value="listing"
                  control={<Radio />}
                  label="Sthanick Services"
                  disabled={isEditMode}
                />
              </RadioGroup>
              {errors.productType && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.productType}
                </Typography>
              )}
            </FormControl>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FormControl fullWidth margin="dense">
                <InputLabel id="businessnature-label">
                  Business Nature
                </InputLabel>
                <Select
                  labelId="businessnature-label"
                  id="businessnature-select"
                  value={vendorData?.businessNature || ""}
                  error={!!errors.businessNatureDropdown}
                  onChange={(e) =>
                    setVendorData({
                      ...vendorData,
                      businessNature: e.target.value,
                    })
                  }
                  label="Business Nature"
                >
                  {/* Dynamically render options based on business nature data */}
                  {natureData && natureData.length > 0 ? (
                    natureData.map((businessNature) => (
                      <MenuItem
                        key={businessNature.business_id}
                        value={businessNature.business_id}
                      >
                        {businessNature.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No business nature available</MenuItem>
                  )}
                </Select>

                {errors.businessNatureDropdown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.businessNatureDropdown}
                    </Typography>
                  </helperText>
                )}
              </FormControl>

              <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>
                {/* <Select
                  labelId="status-label"
                  id="status-select"
                  value={vendorData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setVendorData({
                      ...vendorData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {moduleStatusData &&
                  typeof moduleStatusData.options === "string" ? (
                    moduleStatusData.options.split(",").map((option, index) => (
                      <MenuItem key={index} value={option.trim()}>
                        {option.trim()}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No status data available</MenuItem>
                  )}
                </Select> */}

                <Select
                  labelId="status-label"
                  id="status-select"
                  value={vendorData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setVendorData({
                      ...vendorData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {[
                    "pending",
                    "in-progress",
                    "verified",
                    "stopped",
                    "rejected",
                  ].map((status, index) => (
                    <MenuItem key={index} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>

                {errors.statusDropdown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.statusDropdown}
                    </Typography>
                  </helperText>
                )}
              </FormControl>

              {vendorData?.productType === "regular" && (
                <FormControl fullWidth margin="dense">
                  <InputLabel id="category-label">Category</InputLabel>
                  <Select
                    labelId="category-label"
                    id="category-select"
                    multiple
                    value={
                      Array.isArray(vendorData?.category)
                        ? vendorData.category
                        : []
                    }
                    error={!!errors.categoryDropdown}
                    onChange={(e) => {
                      const selectedCategories = e.target.value;
                      setVendorData({
                        ...vendorData,
                        category: Array.isArray(selectedCategories)
                          ? selectedCategories
                          : [],
                      });
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0) return "Select Categories";

                      // Check if categoryData is an array before calling .filter()
                      const categoriesToDisplay = Array.isArray(categoryData)
                        ? categoryData.filter((category) =>
                            selected.includes(category.category_id),
                          )
                        : [];

                      return categoriesToDisplay
                        .map((category) => category.name)
                        .join(", ");
                    }}
                    label="Category"
                  >
                    {Array.isArray(categoryData) && categoryData.length > 0 ? (
                      categoryData.map((category) => (
                        <MenuItem
                          key={category.category_id}
                          value={category.category_id}
                        >
                          <Checkbox
                            checked={
                              Array.isArray(vendorData?.category) &&
                              vendorData?.category.includes(
                                category.category_id,
                              )
                            }
                          />
                          {category.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No categories available</MenuItem>
                    )}
                  </Select>
                  {errors.categoryDropdown && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.categoryDropdown}
                    </Typography>
                  )}
                </FormControl>
              )}

              {/* Listing category */}
              {vendorData?.productType === "listing" && (
                <FormControl fullWidth margin="dense">
                  <InputLabel id="listing-category-label">
                    Listing Category
                  </InputLabel>
                  <Select
                    labelId="listing-category-label"
                    id="listing-category-select"
                    multiple
                    value={
                      Array.isArray(vendorData?.listingCategory)
                        ? vendorData.listingCategory
                        : []
                    }
                    error={!!errors.listingCategoryDropdown}
                    onChange={(e) => {
                      const selectedCategories = e.target.value;
                      setVendorData({
                        ...vendorData,
                        listingCategory: Array.isArray(selectedCategories)
                          ? selectedCategories
                          : [],
                      });
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0)
                        return "Select Listing Categories";

                      const selectedCategories = Array.isArray(
                        listingCategoryData,
                      )
                        ? listingCategoryData.filter((category) =>
                            selected.includes(category.category_id),
                          )
                        : [];

                      return selectedCategories
                        .map((category) => category.name)
                        .join(", ");
                    }}
                    label="Listing Category"
                  >
                    {Array.isArray(listingCategoryData) &&
                    listingCategoryData.length > 0 ? (
                      listingCategoryData.map((category) => (
                        <MenuItem
                          key={category.category_id}
                          value={category.category_id}
                        >
                          <Checkbox
                            checked={
                              Array.isArray(vendorData?.listingCategory) &&
                              vendorData?.listingCategory.includes(
                                category.category_id,
                              )
                            }
                          />
                          {category.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>
                        No listing categories available
                      </MenuItem>
                    )}
                  </Select>
                  {errors.listingCategoryDropdown && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.listingCategoryDropdown}
                    </Typography>
                  )}
                </FormControl>
              )}
            </Box>

            {/* Profile Photo Section */}
            <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                  Store Image(Either Front or inside store image)
                </Typography>
                <Avatar
                  alt="Image"
                  src={vendorData?.profilePhoto || "/default-profile.png"}
                  sx={{
                    width: 150,
                    height: 150,
                    border: "2px solid #ddd",
                    mb: 1,
                    borderRadius: 0,
                  }}
                />
                <Typography variant="body2" color="textSecondary" marginTop={1}>
                  Required: 300 × 300 pixels
                </Typography>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  display="block"
                >
                  Max size: 40KB (JPEG/PNG)
                </Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFile />}
                  sx={{
                    mr: 2,
                    bgcolor: "#3f51b5",
                    "&:hover": { bgcolor: "#303f9f" },
                  }}
                >
                  Upload Image
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleProfileImage}
                  />
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<Delete />}
                  onClick={() => {
                    setVendorData((prevData) => ({
                      ...prevData,
                      profilePhoto: "",
                    }));
                  }}
                  sx={{
                    color: "#f44336",
                    borderColor: "#f44336",
                    "&:hover": { bgcolor: "#ffe6e6" },
                  }}
                >
                  Delete
                </Button>
                {errors.profilePhoto && (
                  <helperText>
                    <Typography
                      sx={{
                        mt: 2,
                        color: "red",
                        fontWeight: "bold",
                        fontSize: 12,
                      }}
                    >
                      {errors.profilePhoto}
                    </Typography>
                  </helperText>
                )}
              </Grid>
            </Grid>

            <Box sx={{}}>
              <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
                {selectedFiles.length > 0 ? (
                  <img
                    src={URL.createObjectURL(selectedFiles[0])}
                    alt="Product"
                    style={{ width: "80%" }}
                  />
                ) : (
                  <img
                    src={vendorData?.storeImage || "/placeholder.jpg"}
                    alt="Placeholder"
                    style={{ width: "30%" }}
                  />
                )}
              </StyledPaper>
              {errors.storeImage && (
                <helperText>
                  <Typography
                    sx={{
                      mt: 2,
                      color: "red",
                      fontWeight: "bold",
                      fontSize: 12,
                    }}
                  >
                    {errors.storeImage}
                  </Typography>
                </helperText>
              )}
              <StyledPaper>
                <Typography variant="h6" gutterBottom>
                  Store Image(Banner/Flexi,Front side of the store view)
                </Typography>
                <Box
                  sx={{
                    border: "2px dashed #ddd",
                    borderRadius: "4px",
                    p: 2,
                    textAlign: "center",
                    mb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => imageInputRef.current?.click()}
                >
                  <img
                    src="/ph_image-light.svg"
                    alt="Product"
                    style={{ width: "20%" }}
                  />
                  <Typography variant="h6">Add Store Banner</Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    gutterBottom
                  >
                    Required: 1250 x 400 pixels
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Max size: 60KB | Format: JPEG, PNG
                  </Typography>
                  <input
                    type="file"
                    accept="image/jpeg, image/png"
                    multiple
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    onChange={handleStoreImage}
                  />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {selectedFiles.map((file, index) => (
                    <ImageItem
                      key={index}
                      name={URL.createObjectURL(file)}
                      error={
                        file.type !== "image/jpeg" && file.type !== "image/png"
                      }
                      onRemove={() => {
                        setSelectedFiles((prevFiles) =>
                          prevFiles.filter((_, i) => i !== index),
                        );
                      }}
                    />
                  ))}
                </Box>
              </StyledPaper>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                mt: 2,
                justifyContent: "space-between",
              }}
            >
              <FormControl fullWidth sx={{ flex: 2 }}>
                <Typography sx={{ marginBottom: "8px" }}>
                  Opening Time
                </Typography>
                <Select
                  value={vendorData?.openingTime || ""}
                  onChange={(e) =>
                    setVendorData({
                      ...vendorData,
                      openingTime: e.target.value,
                    })
                  }
                  error={!!errors.openingTimeDropdown}
                  displayEmpty
                  sx={{ height: "40px" }}
                >
                  <MenuItem value="" disabled>
                    Select morning time
                  </MenuItem>
                  <MenuItem value="12:00 AM">12:00 AM</MenuItem>
                  <MenuItem value="12:30 AM">12:30 AM</MenuItem>
                  <MenuItem value="01:00 AM">01:00 AM</MenuItem>
                  <MenuItem value="01:30 AM">01:30 AM</MenuItem>
                  <MenuItem value="02:00 AM">02:00 AM</MenuItem>
                  <MenuItem value="02:30 AM">02:30 AM</MenuItem>
                  <MenuItem value="03:00 AM">03:00 AM</MenuItem>
                  <MenuItem value="03:30 AM">03:30 AM</MenuItem>
                  <MenuItem value="04:00 AM">04:00 AM</MenuItem>
                  <MenuItem value="04:30 AM">04:30 AM</MenuItem>
                  <MenuItem value="05:00 AM">05:00 AM</MenuItem>
                  <MenuItem value="05:30 AM">05:30 AM</MenuItem>
                  <MenuItem value="06:00 AM">06:00 AM</MenuItem>
                  <MenuItem value="06:30 AM">06:30 AM</MenuItem>
                  <MenuItem value="07:00 AM">07:00 AM</MenuItem>
                  <MenuItem value="07:30 AM">07:30 AM</MenuItem>
                  <MenuItem value="08:00 AM">08:00 AM</MenuItem>
                  <MenuItem value="08:30 AM">08:30 AM</MenuItem>
                  <MenuItem value="09:00 AM">09:00 AM</MenuItem>
                  <MenuItem value="09:30 AM">09:30 AM</MenuItem>
                  <MenuItem value="10:00 AM">10:00 AM</MenuItem>
                  <MenuItem value="10:30 AM">10:30 AM</MenuItem>
                  <MenuItem value="11:00 AM">11:00 AM</MenuItem>
                  <MenuItem value="11:30 AM">11:30 AM</MenuItem>
                </Select>
                {errors.openingTimeDropdown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.openingTimeDropdown}
                    </Typography>
                  </helperText>
                )}
              </FormControl>
              <FormControl fullWidth sx={{ flex: 2 }}>
                <Typography sx={{ marginBottom: "8px" }}>
                  Evening Time
                </Typography>
                <Select
                  value={vendorData?.eveningTime || ""}
                  onChange={(e) =>
                    setVendorData({
                      ...vendorData,
                      eveningTime: e.target.value,
                    })
                  }
                  error={!!errors.eveningTimeDropDown}
                  displayEmpty
                  sx={{ height: "40px" }}
                >
                  <MenuItem value="" disabled>
                    Select evening time
                  </MenuItem>
                  <MenuItem value="12:00 PM">12:00 PM</MenuItem>
                  <MenuItem value="12:30 PM">12:30 PM</MenuItem>
                  <MenuItem value="01:00 PM">01:00 PM</MenuItem>
                  <MenuItem value="01:30 PM">01:30 PM</MenuItem>
                  <MenuItem value="02:00 PM">02:00 PM</MenuItem>
                  <MenuItem value="02:30 PM">02:30 PM</MenuItem>
                  <MenuItem value="03:00 PM">03:00 PM</MenuItem>
                  <MenuItem value="03:30 PM">03:30 PM</MenuItem>
                  <MenuItem value="04:00 PM">04:00 PM</MenuItem>
                  <MenuItem value="04:30 PM">04:30 PM</MenuItem>
                  <MenuItem value="05:00 PM">05:00 PM</MenuItem>
                  <MenuItem value="05:30 PM">05:30 PM</MenuItem>
                  <MenuItem value="06:00 PM">06:00 PM</MenuItem>
                  <MenuItem value="06:30 PM">06:30 PM</MenuItem>
                  <MenuItem value="07:00 PM">07:00 PM</MenuItem>
                  <MenuItem value="07:30 PM">07:30 PM</MenuItem>
                  <MenuItem value="08:00 PM">08:00 PM</MenuItem>
                  <MenuItem value="08:30 PM">08:30 PM</MenuItem>
                  <MenuItem value="09:00 PM">09:00 PM</MenuItem>
                  <MenuItem value="09:30 PM">09:30 PM</MenuItem>
                  <MenuItem value="10:00 PM">10:00 PM</MenuItem>
                  <MenuItem value="10:30 PM">10:30 PM</MenuItem>
                  <MenuItem value="11:00 PM">11:00 PM</MenuItem>
                  <MenuItem value="11:30 PM">11:30 PM</MenuItem>
                </Select>
                {errors.eveningTimeDropDown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.eveningTimeDropDown}
                    </Typography>
                  </helperText>
                )}
              </FormControl>

              <Box sx={{ flex: 2, mt: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Date of Birth"
                    value={vendorData.dob ? new Date(vendorData.dob) : null}
                    maxDate={new Date()}
                    onChange={(newValue) => {
                      setVendorData({ ...vendorData, dob: newValue });

                      // Clear error if the date is valid
                      if (newValue) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          dob: null,
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        sx={{ mb: 4 }}
                        error={!!errors.dob}
                      />
                    )}
                  />
                  {errors.dob && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.dob}
                    </Typography>
                  )}
                </LocalizationProvider>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Aadhar Number"
                type="tel"
                fullWidth
                value={vendorData?.aadhar || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, aadhar: e.target.value })
                }
                error={!!errors.aadhar}
                helperText={
                  errors.aadhar && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.aadhar}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="Pan Number"
                type="tel"
                fullWidth
                value={vendorData?.pan || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, pan: e.target.value })
                }
                error={!!errors.pan}
                helperText={
                  errors.pan && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.pan}
                    </Typography>
                  )
                }
                placeholder="Example: ABCDE1234F"
              />
              <TextField
                margin="dense"
                label="G.S.T No"
                type="tel"
                fullWidth
                value={vendorData?.gst || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, gst: e.target.value })
                }
                error={!!errors.gst}
                helperText={
                  errors.gst && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.gst}
                    </Typography>
                  )
                }
                placeholder="Example: 27AAAPA1234A1Z5"
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6">Address</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Country"
                type="tel"
                fullWidth
                value={vendorData?.country || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, country: e.target.value })
                }
                error={!!errors.country}
                helperText={
                  errors.country && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.country}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="State"
                type="tel"
                fullWidth
                value={vendorData?.state || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, state: e.target.value })
                }
                error={!!errors.state}
                helperText={
                  errors.state && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.state}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="City"
                type="tel"
                fullWidth
                value={vendorData?.location || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, city: vendorData?.location })
                }
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Street Address"
                type="tel"
                fullWidth
                value={vendorData?.street || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, street: e.target.value })
                }
                error={!!errors.street}
                helperText={
                  errors.street && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.street}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Land mark"
                type="tel"
                fullWidth
                value={vendorData?.landmark || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, landmark: e.target.value })
                }
                error={!!errors.landmark}
                helperText={
                  errors.landmark && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.landmark}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="Pin code"
                type="tel"
                fullWidth
                value={vendorData?.pincode || ""}
                onChange={(e) =>
                  setVendorData({ ...vendorData, pincode: e.target.value })
                }
                error={!!errors.pincode}
                helperText={
                  errors.pincode && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.pincode}
                    </Typography>
                  )
                }
              />
            </Box>

            <Box>
              <Typography variant="h6">Select Location</Typography>

              {/* Search Box */}
              <TextField
                fullWidth
                margin="dense"
                label="Search Location"
                variant="outlined"
                sx={{ mt: 2 }}
                value={vendorData?.searchlocation}
                onChange={handleLocationSearch}
                error={!!errors.searchlocation}
                helperText={
                  errors.searchlocation && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.searchlocation}
                    </Typography>
                  )
                }
              />

              {/* Map Container */}
              <Box sx={{ padding: 3 }}>
                <GoogleMap
                  ref={mapRef}
                  onLoad={(map) => {
                    mapRef.current = map;
                    if (vendorData.latitude && vendorData.longitude) {
                      map.panTo({
                        lat: parseFloat(vendorData.latitude),
                        lng: parseFloat(vendorData.longitude),
                      });
                      map.setZoom(15);
                    }
                  }}
                  center={{
                    lat: parseFloat(vendorData.latitude) || 0,
                    lng: parseFloat(vendorData.longitude) || 0,
                  }}
                  zoom={13}
                  mapContainerStyle={{
                    height: "400px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                  }}
                  // ✅ Click anywhere on map to move marker
                  onClick={(e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setVendorData((prevData) => ({
                      ...prevData,
                      latitude: lat,
                      longitude: lng,
                    }));
                  }}
                >
                  {vendorData.latitude && vendorData.longitude && (
                    <MarkerF
                      ref={markerRef}
                      position={{
                        lat: parseFloat(vendorData.latitude),
                        lng: parseFloat(vendorData.longitude),
                      }}
                      icon={createRedIcon()}
                      draggable={true} // ✅ Allow dragging
                      // ✅ Update position when dragged
                      onDragEnd={(e) => {
                        const lat = e.latLng.lat();
                        const lng = e.latLng.lng();
                        setVendorData((prevData) => ({
                          ...prevData,
                          latitude: lat,
                          longitude: lng,
                        }));
                      }}
                      onClick={() => setInfoWindowOpen(true)}
                    >
                      {isInfoWindowOpen && (
                        <InfoWindowF
                          position={{
                            lat: parseFloat(vendorData.latitude),
                            lng: parseFloat(vendorData.longitude),
                          }}
                          onCloseClick={() => setInfoWindowOpen(false)}
                        >
                          <div>
                            <p>
                              Latitude: {vendorData.latitude}, Longitude:{" "}
                              {vendorData.longitude}
                            </p>
                          </div>
                        </InfoWindowF>
                      )}
                    </MarkerF>
                  )}
                </GoogleMap>
              </Box>

              {/* Latitude and Longitude Text Fields */}
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <TextField
                  margin="dense"
                  label="Latitude"
                  type="text"
                  fullWidth
                  value={vendorData?.latitude}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  margin="dense"
                  label="Longitude"
                  type="text"
                  fullWidth
                  value={vendorData?.longitude || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                onClick={() => setOpen(false)}
                sx={{ marginRight: 2, color: "white", backgroundColor: "red" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                sx={{ color: "white", backgroundColor: "green" }}
              >
                {isEditMode ? "Update" : "Add"}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Modal for View Icon */}
        <Modal
          open={openViewModal}
          onClose={handleViewClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll",
              borderRadius: 2,
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
                {vendorData?.id ? "Edit Vendor" : "View Vendor"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={handleViewClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ width: "100%", padding: 2 }}>
              <Tabs value={tabValue} onChange={handleTabChange} centered>
                <Tab label="Profile" />
                <Tab label="Performance" />
              </Tabs>

              <TabPanel value={tabValue} index={0}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: "20px" }}>
                  <Typography variant="h6">
                    {vendorviewData?.shopName}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {vendorviewData?.ownerName}
                  </Typography>

                  <Box mt={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Vendor ID"
                          variant="outlined"
                          size="small"
                          value={vendorviewData?.vendorId}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Phone"
                          variant="outlined"
                          size="small"
                          //defaultValue="+91 8900000021"
                          value={vendorviewData?.phoneNumber}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Location"
                          variant="outlined"
                          size="small"
                          value={vendorviewData?.location}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Status"
                          variant="outlined"
                          size="small"
                          value={vendorviewData?.status}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Total Orders"
                          variant="outlined"
                          size="small"
                          value={
                            deliveredOrdersLoading ? "Loading..." : totalOrders
                          }
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Total Received Amount"
                          variant="outlined"
                          size="small"
                          value={
                            deliveredOrdersLoading
                              ? "Loading..."
                              : `₹${Number(totalReceivedAmount).toLocaleString("en-IN")}`
                          }
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Email"
                          variant="outlined"
                          size="small"
                          value={vendorviewData?.email}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Address"
                          variant="outlined"
                          size="small"
                          multiline
                          rows={3}
                          value={vendorviewData?.address}
                        />
                      </Grid>
                    </Grid>

                    <Box mt={3}>
                      <Typography variant="body1" fontWeight="bold">
                        Bank Account Details
                      </Typography>

                      {paymentRequestsLoading ? (
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading bank details...
                        </Typography>
                      ) : paymentRequestsError ? (
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{ mt: 1 }}
                        >
                          Failed to load bank details.
                        </Typography>
                      ) : bankDetails.length === 0 ? (
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ mt: 1 }}
                        >
                          No bank details found.
                        </Typography>
                      ) : (
                        bankDetails.map((bank, index) => (
                          <Paper
                            key={index}
                            elevation={1}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: 2,
                              mt: 1,
                            }}
                          >
                            <Box>
                              <Typography variant="body1">
                                {bank.bank_name || "N/A"}
                              </Typography>

                              <Typography variant="body2" color="textSecondary">
                                {bank.bank_holder_name || "N/A"}
                              </Typography>

                              <Typography variant="body2" color="textSecondary">
                                {bank.account_number || "N/A"}
                              </Typography>

                              <Typography variant="body2" color="textSecondary">
                                {bank.ifsc_code || "N/A"}
                              </Typography>

                              <Typography variant="body2" color="textSecondary">
                                {bank.branch_name || "N/A"}
                              </Typography>
                            </Box>
                          </Paper>
                        ))
                      )}
                    </Box>
                  </Box>
                </Paper>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: "20px" }}>
                  <Typography variant="h6">Performance Metrics</Typography>

                  <Box mt={3}>
                    <Grid container spacing={2}>
                      {cards.map((card, index) => (
                        <Grid item xs={12} sm={6} md={2.4} key={index}>
                          <Card
                            sx={{
                              borderRadius: "12px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                              mt: 3,
                            }}
                          >
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "nowrap",
                                }}
                              >
                                <img
                                  src={card.image}
                                  alt={card.title}
                                  style={{ width: "40px", marginRight: "10px" }}
                                />
                                <Box>
                                  <Typography
                                    color="textSecondary"
                                    gutterBottom
                                    noWrap
                                    sx={{
                                      fontSize: "0.658rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {card.title}
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    component="div"
                                    sx={{
                                      fontSize: "1rem",
                                      fontWeight: "bold",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {card.value}
                                  </Typography>
                                </Box>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Paper>
              </TabPanel>
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mt: "13%" }}
            >
              <Button
                onClick={handleViewClose}
                sx={{ color: "white", backgroundColor: "red" }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
        <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default VendorManagement;
